import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo3.webp"; 
import "../styles/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  const location = useLocation();

  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-page-wrapper">
      {/* Header Section */}
      <header className="contact-header over-banner">
        <div className="contact-logo">
          <img src={logo} alt="TravelKariye Logo" />
        </div>
        <nav className="contact-nav">
          <Link to="/" className={location.pathname === '/' ? 'active-link' : ''}>Home</Link>
          <Link to="/packages">Packages</Link>
          <div className="contact-dropdown">
            <span className={`contact-dropbtn ${['/goa', '/abu', '/dubai'].includes(location.pathname) ? 'active-link' : ''}`}>
              Destinations
            </span>
            <div className="contact-dropdown-content">
              <Link to="/goa">Goa</Link>
              <Link to="/kerala">Kerala</Link>
              <Link to="/rajasthan">Rajasthan</Link>
              <Link to="/himachal">Himachal Pradesh</Link>
              <Link to="/uttarakhand">Uttarakhand</Link>
              <Link to="/abu">Abu Dhabi</Link>
              <Link to="/dubai">Dubai</Link>
            </div>
          </div>
          <Link to="/hotels">Hotels</Link>
          <Link to="/contact-us" className={location.pathname === '/contact-us' ? 'active-link' : ''}>Contact Us</Link>
        </nav>
        <Link to="/booknow">
          <button className="contact-book-btn">Book Now</button>
        </Link>
      </header>

      {/* Hero Section: Title and Subtitle stay INSIDE here for better visibility */}
      <div className="policy-hero-spacer">
        <div className="policy-header-text">
          <span className="subtitle">TravelKariye Legal</span>
          <h1>Privacy Policy</h1>
        </div>
      </div>

      {/* Content Section: The White Card */}
      <div className="policy-container">
        <div className="policy-card">
          <section>
            <h3>1. Data Collection</h3>
            <p>
              At TravelKariye, we collect information to provide better services to all our travelers. 
              This includes details provided during booking like your name, email address, 
              phone number, and specific travel preferences to ensure a personalized journey.
            </p>
          </section>

          <section>
            <h3>2. Use of Information</h3>
            <p>
              Your data is primarily used to process your hotel and tour bookings, 
              provide customer support, and send timely updates about your curated 
              Indian travel itineraries. We do not sell your personal data to third parties.
            </p>
          </section>

          <section>
            <h3>3. Cookies & Tracking</h3>
            <p>
              We use cookies and similar tracking technologies to track the activity on 
              our service and hold certain information. Cookies help us analyze site traffic 
              to improve our destination recommendations for you.
            </p>
          </section>

          <section>
            <h3>4. Data Security</h3>
            <p>
              The security of your data is important to us. We use commercially acceptable 
              means to protect your Personal Data, including encrypted payment gateways 
              for all transaction-related information.
            </p>
          </section>

          <div className="last-updated">
            <p>Effective Date: April 24, 2026</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;